import { BaseComponent } from '../../../components/BaseComponent';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Home } from '../../../components/Icon';
import { fetchAddress } from '../../Address/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_ADDRESS } from '../../Address/constants';
import { Loader } from '../../../components/Loader';
import { selectAddress, selectAddressTypes } from '../../Address/selectors';
import { HBox, VBox } from '../../../components/Box';
import { translateCountry } from '../../Companies/translate-countries';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';

const STATE = {};

const NotificationIconWrapper = styled.div`
  a {
    position: relative;
  }

  .icon-wrapper {
    font-size: 20px;
    color: ${props => (props.iconColor ? props.iconColor : '#ccc')};
  }

  .alert-alt-block {
    position: absolute;
    top: ${props => (props.top ? props.top : '100%')};
    right: ${props => (props.right ? props.right : '100%')};
    left: ${props => props.left && props.left};
    z-index: 99999999999999;
    min-width: ${props => (props.minWidth ? props.minWidth : '200px')};
    max-width: 500px;
    padding: 4px 8px;
    background-color: #ccc;
    color: black;
    white-space: pre-wrap; /* or pre-line */
    text-align: left;
    border-radius: 5px;
    text-transform: none !important;
  }

  .alert-alt-block .p {
    color: black;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const ADDRESS_COLORS_BY_ADDRESS_TYPE = {
  home: 'rgb(21, 172, 121)',
  delivery: 'orange',
  invoice: 'darkviolet',
  visiting: '#D50046',
  mailing: 'blue',
};

class HomeAddressLabelComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetch();
  }

  get address() {
    return this.props.address;
  }

  get addressTypes() {
    return this.props.addressTypes;
  }

  get locale() {
    return this.props.locale;
  }

  get iconColor() {
    const addressType = this.address?.type?.name;
    const color = ADDRESS_COLORS_BY_ADDRESS_TYPE[addressType];

    return color;
  }

  isHovered(hoveredOption, vehicleId) {
    this.setState({ isHover: hoveredOption, hoveredId: vehicleId });
  }

  reset() {
    this.setState({ ...STATE });
  }

  renderAddress() {
    const address = this.address;
    return (
      <Address key={`${address.id}`}>
        <VBox left>
          <HBox vCenter>
            <h3 className="name">{this.lbl(`address.type.${address.type?.name}`)}</h3>
          </HBox>

          <VBox className="address" left>
            <div>{address.addressLine1}</div>
            <div>
              {address.postcode} {address.city}
            </div>
            <div>{translateCountry(address.country?.name, this.locale)}</div>
          </VBox>

          <VBox className="address" left>
            <strong>{this.lbl('company.details.comment')}</strong>
            {address.description}
          </VBox>
        </VBox>
      </Address>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    const { minWidth, top, right, left } = this.props;
    return (
      <NotificationIconWrapper minWidth={minWidth} top={top} right={right} left={left} iconColor={this.iconColor}>
        <a onMouseEnter={() => this.isHovered(true)} onMouseLeave={() => this.isHovered(false)}>
          <div className="icon-wrapper">
            <Home />
          </div>
          {this.state.isHover && <div className="alert-alt-block">{this.renderAddress()}</div>}
        </a>
      </NotificationIconWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(`${REQUEST_ADDRESS}-${ownProps.address_id}`),
    address: selectAddress(ownProps.address_id),
    addressTypes: selectAddressTypes(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(callback) {
      dispatch(fetchAddress(ownProps.address_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HomeAddressLabel = compose(withConnect, withRouter)(HomeAddressLabelComp);
